var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0703 3.59399H2.65234C2.40625 3.59399 2.21484 3.40259 2.21484 3.15649C2.21484 2.93774 2.40625 2.71899 2.65234 2.71899H13.1523C13.3711 2.71899 13.5898 2.52759 13.5898 2.28149C13.5898 1.57056 12.9883 0.968994 12.2773 0.968994H2.21484C1.23047 0.968994 0.464844 1.76196 0.464844 2.71899V11.469C0.464844 12.4534 1.23047 13.219 2.21484 13.219H13.0703C13.8359 13.219 14.4648 12.6448 14.4648 11.9065V4.90649C14.4648 4.19556 13.8359 3.59399 13.0703 3.59399ZM11.8398 9.28149C11.3477 9.28149 10.9648 8.89868 10.9648 8.40649C10.9648 7.94165 11.3477 7.53149 11.8398 7.53149C12.3047 7.53149 12.7148 7.94165 12.7148 8.40649C12.7148 8.89868 12.3047 9.28149 11.8398 9.28149Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d2e430864d69192e38b1f43a86c63d8b.svg";
export { ForwardRef as ReactComponent };